import Backdrop from '@mui/material/Backdrop';
import { useEffect, useState } from 'react';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import apiClient from '../../apiClient';
import { SetSuccessMessage, SetErrorMessage, HandleAuthError, GenericStackTraceValidator } from '../universal/Alert';
import { getStore } from '../../Store';

import {
    Button,
    TextField,
    Box,
    Stack,
} from '@mui/material';

const store = getStore();

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    height: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const EditComparativeSetDescriptionModal = ({ comparative_set_id, open, setClose, current_description }) => {
    const [description, setDescription] = useState(current_description);

    useEffect(() => {
        setDescription(current_description)
    }, [current_description])

    const editComparativeSetDescription = () => {
        apiClient.post(
            "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
            {
                "function_to_execute": "Update_Comparative_Set_Description",
                "comparative_set_id": comparative_set_id,
                "description": description
            }
        ).then(() => {
            store.updateSuccessMessage("Successfully updated comparative set description!")
            setClose()
        }).catch(function (error) {
            if (error?.response?.status === 401) {
                HandleAuthError()
            } else {
                console.log(error?.response?.data)
                //alert(error?.response?.data)
            }
            setClose()
        });
    }

    return (
        <div>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={setClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open}>
                    <Box sx={modalStyle}>
                        <Stack direction="row" spacing={1}>
                            <TextField
                                id="description"
                                label="Description"
                                required
                                variant="outlined"
                                onChange={(event) => setDescription(event.target.value)}
                                value={description}
                                InputLabelProps={{}}
                                sx={{ width: '100%' }}
                            />
                        </Stack>
                        <Button
                            variant="contained"
                            onClick={() => editComparativeSetDescription()}
                            style={{ marginRight: "10px" }}
                        >Submit</Button>
                        <Button
                            variant="contained"
                            onClick={() => setClose()}
                        >Cancel</Button>
                    </Box>
                </Fade>
            </Modal>
        </div>
    );
}

export default EditComparativeSetDescriptionModal;